import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";

export default class WhatsappShareLinkGenerator implements ShariffLinkGeneratorInterface {
    public generateLink(url: string): string {
        return "whatsapp://send?text=" + encodeURIComponent(url);
    }
}
